import React from 'react';
import './TextArea.css';

function TextArea({
  id,
  rows = 4,
  resize = 'vertical',
  error = false,
  disabled = false,
  className = '',
  ...rest
}) {
  const classes = [
    'ui-textarea',
    error ? 'ui-textarea--error' : '',
    resize === 'none' ? 'ui-textarea--no-resize' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <textarea
      id={id}
      rows={rows}
      className={classes}
      disabled={disabled}
      aria-invalid={error || undefined}
      {...rest}
    />
  );
}

export default TextArea;
